export default "__VITE_ASSET__BmSVQ3O0__"